export default __webpack_public_path__ + "static/media/Pot2.15ecbbe3.svg";